import SiteImage from "./SiteImage";
import { responsiveImageSet } from "@/lib/publicAssets";

type ResponsiveBackgroundProps = {
  desktopSrc: string;
  mobileSrc?: string;
  desktopSrcSet?: string;
  mobileSrcSet?: string;
  mobileMedia?: string;
  desktopMedia?: string;
  className?: string;
  loading?: "eager" | "lazy";
  fetchPriority?: "high" | "low" | "auto";
};

export default function ResponsiveBackground({
  desktopSrc,
  mobileSrc,
  desktopSrcSet,
  mobileSrcSet,
  mobileMedia = "(max-width: 767px)",
  desktopMedia = "(min-width: 768px)",
  className = "",
  loading = "lazy",
  fetchPriority = "auto",
}: ResponsiveBackgroundProps) {
  return (
    <picture className={`absolute inset-0 block ${className}`} aria-hidden="true">
      {mobileSrc && <source media={mobileMedia} type="image/avif" srcSet={responsiveImageSet(mobileSrcSet ?? mobileSrc, "avif")} sizes="100vw" />}
      {mobileSrc && (
        <source
          media={mobileMedia}
          srcSet={responsiveImageSet(mobileSrcSet ?? mobileSrc, "webp")}
          sizes="100vw"
        />
      )}
      <source media={mobileSrc ? desktopMedia : undefined} type="image/avif" srcSet={responsiveImageSet(desktopSrcSet ?? desktopSrc, "avif")} sizes="100vw" />
      <SiteImage
        src={desktopSrc}
        srcSet={responsiveImageSet(desktopSrcSet ?? desktopSrc, "webp")}
        sizes="100vw"
        alt=""
        loading={loading}
        fetchPriority={fetchPriority}
        decoding="async"
        className="h-full w-full object-cover object-center"
      />
    </picture>
  );
}